import React, { useState } from 'react';
import { useStyles } from './ProjectRoleInfoStyles';
import Tabs from './Tabs/Tabs';
import { IAuditionScheduleAttributes } from 'shared/interfaces/IAuditionSchedule';
import LocationAndDates from './Role/LocationAndDates/LocationAndDates';

type Props = {
  auditionSchedule: IAuditionScheduleAttributes | undefined;
};

const ProjectRoleInfo: React.FC<Props> = ({ auditionSchedule }) => {
  const classes = useStyles();
  const [tab, setTab] = useState<'project' | 'role'>('project');

  const AsyncProject = React.lazy(() => import('./Project'));
  const AsyncRole = React.lazy(() => import('./Role'));

  const isSelftTapes = auditionSchedule?.phase === 'Self Tapes Request';

  return (
    <div className={classes.root}>
      {/* {isSelftTapes ? (
        <React.Fragment />
      ) : ( */}
      <div className={classes.content}>
        <LocationAndDates
          data={
            auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
              ? auditionSchedule.audition.casting_role
              : undefined
          }
        />
      </div>
      {/* )} */}
      <div className={classes.content}>
        <AsyncRole
          data={
            auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
              ? auditionSchedule.audition.casting_role
              : undefined
          }
        />
      </div>
      <div className={classes.content}>
        <AsyncProject
          data={
            auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
              ? auditionSchedule.audition.casting_role
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default ProjectRoleInfo;
